// extracted by mini-css-extract-plugin
module.exports = {"ratings-reviews-tab-container":"RatingsAndReviewTab_ratings-reviews-tab-container__AcLu2","review-heading":"RatingsAndReviewTab_review-heading__FxR5E"};